import { useEffect } from 'react';
import { useGetConversationById, useSetConversation } from 'hooks/business/lruConversation';
import { useSetSearchConversation } from 'hooks/business/conversation';
import { useOpenConversation } from 'hooks/business/conversationsHooks/useOpenConversation';
import { useSetSearchMsgSelectedSendTime } from 'hooks/business/searchMsgSelectedMsg';
import { getTalkInfo } from 'services/api/conversation.convList';

interface UseOpenConversationFromQueryParams {
  category: 'mine' | 'all';
  conversationIdFromQuery?: string;
}

export const useOpenConversationFromQuery = ({
  category,
  conversationIdFromQuery,
}: UseOpenConversationFromQueryParams) => {
  const getConversationById = useGetConversationById();
  const setConversation = useSetConversation();
  const setSearchConversation = useSetSearchConversation();
  const setSearchMsgSelectedSendTime = useSetSearchMsgSelectedSendTime();
  const openConversation = useOpenConversation();

  useEffect(() => {
    if (!conversationIdFromQuery || !/^\d+$/.test(conversationIdFromQuery)) return;

    const cachedConversation = getConversationById(conversationIdFromQuery);
    const loader = cachedConversation
      ? Promise.resolve(cachedConversation)
      : getTalkInfo({ conversationId: conversationIdFromQuery, suTalkMode: category === 'all' });

    loader
      .then((conversation) => {
        setConversation(conversationIdFromQuery, conversation);
        // URL 跳转打开的会话不进入会话列表，仅注册到搜索会话状态（作为当前会话的数据兜底）
        setSearchConversation(conversation);
        setSearchMsgSelectedSendTime({ msgId: '', sendTime: '' });
        openConversation(conversation, { category });
      })
      .catch((error) => {
        console.error('Failed to open conversation from query:', error);
      });
  }, [
    category,
    conversationIdFromQuery,
    getConversationById,
    openConversation,
    setConversation,
    setSearchConversation,
    setSearchMsgSelectedSendTime,
  ]);
};
